import { Container, Divider } from "@material-ui/core";
import { Grid } from "@mui/material";
import axios from "axios";
import {
  ButtonGroupTop,
  CheckboxInput,
  CustomTable,
  ModalError,
  ModalSuccess,
  Page,
  PrimaryButton,
  SectionLabel,
  SelectInput,
  SkeletonComponent,
  ArrayChip,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors, textCapitalization } from "utils";

function Pembayaran() {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const paramsDomicile = urlParams?.get("domecile");
  const paramsPage = urlParams?.get("page");
  const paramsSize = urlParams?.get("size");
  const classes = globalStyles();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [loadingPage, setLoadingPage] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [domicile, setDomicile] = useState("domestic");
  const [queryParams, setQueryParams] = useState({
    page: Number(paramsPage) || 1,
    size: Number(paramsSize) || 10,
    domicile: paramsDomicile || "domestic",
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);

  const handleChangePageParams = (value, key) => {
    urlParams.set(key, value);
    history.replace({
      pathname: location.pathname,
      search: urlParams.toString(),
    });
  };
  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
    handleChangePageParams(value, key);
    if (key !== "page") {
      handleChangePageParams(1, "page");
    }
  };

  const handleCheckTax = (event, id) => {
    const { checked } = event?.target;
    setDataTable(currentState =>
      currentState.map(item =>
        item.id === id ? { ...item, is_active_flag: checked } : item
      )
    );
  };

  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/publisher/configuration/tax`,
        {
          headers,
          params: queryParams,
        }
      );
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.size || 1);
      setTableTotalPage(pageCount);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const handleSaveChanges = async () => {
    const payload = {
      domicile,
      taxes: dataTable?.map(item => ({
        id: item?.id,
        is_active_flag: item?.is_active_flag,
      })),
    };
    try {
      setLoadingButton(true);
      await axios.post(`${hardBaseUrl}/publisher/configuration/tax`, payload, {
        headers,
      });
      ModalSuccess(
        "Client's tax setting successfully saved, check the detail information at the table"
      ).then(() => getDataTable());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingButton(false);
    }
  };

  useEffect(() => {
    getDataTable();
  }, [domicile]);

  return (
    <Page className={classes.root} title="Tax">
      <Container maxWidth={false}>
        <HeaderTitle title="Configuration" breadcrumbData={breadcrumbData} />
        <ButtonGroupTop />
        <Divider className={classes.flatDivider} />
        <Grid container justifyContent="space-between" my="16px">
          <Grid item>
            <SectionLabel
              title="Tax"
              subTitle="Feature to settings client's tax"
            />
          </Grid>
          <Grid item>
            <SelectInput
              label="Domicile"
              value={domicile}
              options={optionDomicile}
              optionLabel="name"
              optionKey="value"
              onChange={e => {
                setDomicile(e?.target?.value);
                handleChangeQueryParams(e?.target?.value, "domecile");
              }}
              width={200}
            />
          </Grid>
        </Grid>
        {loadingPage ? (
          <SkeletonComponent variant="wave" />
        ) : (
          <CustomTable
            columnTable={columnTable}
            data={dataTable}
            page={queryParams?.page}
            pageSize={queryParams?.size}
            pageCount={tableTotalPage}
            handleChangePage={(_, page) =>
              handleChangeQueryParams(page, "page")
            }
            handleChangePageSize={e =>
              handleChangeQueryParams(e?.target?.value, "size")
            }
            isHaveAction
            renderAction={item => (
              <CheckboxInput
                disabled={loadingButton}
                checked={item.is_active_flag}
                onChange={e => handleCheckTax(e, item.id)}
              />
            )}
          />
        )}
        <Grid container justifyContent="right" mt="16px">
          <PrimaryButton
            label={`${loadingButton ? "Saving" : "Save"} Changes`}
            onClick={handleSaveChanges}
            disabled={loadingButton}
            loading={loadingButton}
          />
        </Grid>
      </Container>
    </Page>
  );
}

const breadcrumbData = [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Configuration",
    link: "/admin/konfigurasi/tax",
  },
  {
    label: "Tax",
    active: true,
  },
];
const optionDomicile = [
  {
    name: "Domestic",
    value: "domestic",
  },
  {
    name: "Overseas",
    value: "overseas",
  },
];
const columnTable = [
  {
    name: "code",
    title: "Code",
  },
  {
    name: "description",
    title: "Description",
  },
  {
    name: "rate",
    title: "Rate",
    renderText: item => `${item} %`,
  },
  {
    name: "tax_bases",
    title: "Base",
    renderText: item => `${item} %`,
  },
  {
    name: "method",
    title: "Method",
    renderText: item => textCapitalization(item),
  },
  {
    name: "tax_objects",
    title: "Object",
    renderText: tax_objects => {
      const modifiedItems = (tax_objects || [])?.map(
        ({ tax_object, ...rest }) => ({
          ...rest,
          name: textCapitalization(tax_object) || "-",
        })
      );
      return <ArrayChip list={modifiedItems} max={3} />;
    },
  },
];

export default Pembayaran;
